import styled from 'styled-components';

export const StyledAboutOurServicesSection = styled.div`
  .about-our-services-section {
    width: 100%;
    padding: 120px 16px;

    &__inner {
      margin: 0 auto;
      max-width: 1200px;
    }

    &__heading {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-bottom: 64px;
      gap: 16px;
    }

    &__heading-desc {
      max-width: 560px;

      p {
        color: ${({ theme }) => theme.colors.boulder};
      }
    }

    &__grid {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 24px;
    }

    &__card {
      background: ${({ theme }) => theme.colors.white};
      border-radius: 16px;
      padding: 36px 28px;
      display: flex;
      flex-direction: column;
      gap: 20px;
      width: calc(33.333% - 16px);
      border: 1px solid ${({ theme }) => theme.colors.getTransparentColor(theme.colors.mineShaft, 0.06)};
      transition:
        transform 0.3s ease,
        box-shadow 0.3s ease;

      &:hover {
        transform: translateY(-6px);
        box-shadow: 0 12px 40px ${({ theme }) => theme.colors.getTransparentColor(theme.colors.mineShaft, 0.08)};
      }

      @media (max-width: 900px) {
        width: calc(50% - 12px);
      }

      @media (max-width: 600px) {
        width: 100%;
      }
    }

    &__card-icon {
      width: 52px;
      height: 52px;
      border-radius: 12px;
      background: ${({ theme }) => theme.colors.getTransparentColor(theme.colors.mainOrange, 0.1)};
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      svg {
        font-size: 22px;
        color: ${({ theme }) => theme.colors.mainOrange};
      }
    }

    &__card-content {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    &__card-desc {
      p {
        color: ${({ theme }) => theme.colors.boulder};
        line-height: 1.6;
      }
    }
  }

  @media (max-width: 1050px) {
    .about-our-services-section {
      padding: 80px 16px;
    }
  }
`;
